import { Router } from '@angular/router';
import { IAppserverConfiguration } from './../../interfaces/IAppServerConfiguration';
import { IAppserverData } from './../../interfaces/IAppserverData';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, share, take, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppserverConfigurationService {

  readonly appserverConfigurationUrl = 'api/pgv/checkconfigappserver/';
  readonly libVersionUrl = 'shiftf6/';
  availableAPIAppserverConfig = new BehaviorSubject<boolean>(undefined);

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  getAppserverConfiguration(security: string): Observable<IAppserverConfiguration> {
    return this.http.get<IAppserverConfiguration>(`${environment.url}${this.appserverConfigurationUrl}${security}`);
  }

  getAppserverData(): Observable<IAppserverData> {
    return this.http.get<IAppserverData>(`${environment.url}${this.libVersionUrl}`);
  }

  isSecurityEnabled(): Observable<boolean> {
    return this.getAppserverConfiguration('getSecurityKey')
      .pipe(
        take(1),
        share(),
        map(configuration => (configuration?.value === '.T.')),
        catchError(
          (err): Observable<boolean> => this.getHandleError404(err, true)
        )
      );
  }

  isEditCustomerEnabled(): Observable<boolean> {
    return this.getAppserverData()
      .pipe(
        take(1),
        share(),
        map(appserverData => (appserverData?.lib?.version >= '20221010')),
        catchError(
          (err): Observable<boolean> => this.getHandleError404(err, false)
        )
      );
  }

  isAvailableAPIAppserverConfig(): Observable<boolean> {
    if (this.availableAPIAppserverConfig.getValue() === undefined) {
      return this.getAppserverConfiguration('getSecurityKey')
        .pipe(
          take(1),
          share(),
          map( () => true ),
          tap( () => this.availableAPIAppserverConfig.next(true)),
          catchError(
            err => {
              this.availableAPIAppserverConfig.next(false);
              return this.getHandleError404(err, false);
            }
          )
        );
    }else {
      return this.availableAPIAppserverConfig.asObservable().pipe(
        share(),
        take(1)
      );
    }
  }

  getHandleError404(err: HttpErrorResponse, next: boolean): Observable<boolean> {
    if (err.status === 404) {
      const obs$ = new Observable<boolean>(observer => {
        observer.next(next);
      }).pipe(
        take(1)
      );
      return obs$;
    } else {
      return throwError(() => err);
    }
  }

  cantActivate(route: string, queryParams = { id: '' }): Observable<boolean> {
    const obs$ = new Observable<boolean>(observer => {
      observer.next(false);
    });

    obs$.subscribe({
      next: () => {
        this.router.navigate([route], { queryParams: queryParams });
      }
    });

    return obs$;
  }
}
